import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 0 40px 32px 40px;
    font-family: 'Galano', 'Roboto', sans-serif, 'Helvetica Neue', sans-serif;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0 0 16px 0;
    }
  `}
`;
